module.exports = __webpack_public_path__ + "static/media/backgroundIncomingCall.04244602.svg";